import {store} from '../../store/store';

/** Проверяет инициализацию платежного виджета CloudPayments и в случае неуспеха вызывает функцию ошибки оплаты
 * @param {Function} errorPay - функция, которая вызывается при не успешной оплате (коллбэк неудачи)
* */
export let checkInitializationCloudPayments = (errorPay) => (window.cp === void 0) && errorPay('connect_error', undefined);

/** Проверяет инициализацию платежного виджета от Хоум банка и в случае неуспеха вызывает функцию ошибки оплаты
 * @param {Function} errorPay - функция, которая вызывается при не успешной оплате (коллбэк неудачи)
 * */
export let checkInitializationVsegdaDa = (errorPay) => (window.vd === void 0) && errorPay('connect_error');

/** Возвращает текст описания оплаты (информация о заказе для пользователя в платежном виджите)
 * @param {Array} listCourses - список курсов, которые покупает ученик
 * @param {String} typeCourses - тип курса (например: gk, pgk)
 * @return {String} описание курсов, которые покупает пользовоатель
 * */
export let getDescription = (listCourses, typeCourses) => {
  // Получить наименование курса, который ученик покупает
  let getNameCourse = (typeCourses) => {
    switch (typeCourses) {
      case 'gk':
        return 'годового курса';

      case 'pgk':
        return 'полугодового курса';

      case 'ss':
        return 'старта';

      case 'mrt':
        return 'марафона';
    }
  }

  // Получить текст курсов, которые покупает ученик
  let getTextOrderCourses = (listCourses) => {
    return listCourses.reduce((accumulator, item) => {
      if (accumulator.length > 0) accumulator += '; ';
      const text = item.description ? `${ item.name }, ${ item.description }` : `${ item.name }`;
      return accumulator + text;
    }, '');
  };

  let titleCourse = `Покупка ${ getNameCourse(typeCourses) }.`;
  let textCourse = listCourses.length > 1 ? 'Предметы' : 'Предмет';

  return `${ titleCourse } ${ textCourse }: ${ getTextOrderCourses(listCourses) }`;
};

/** Получить publicId для оплаты
 * @returns {Number} ключ оплаты
* */
export let getPublicId = () => {

  const payKeys = store.state.payKeys; // ключи для оплат
  const userIsTester = store.state.auth.other.is_tester;
  return userIsTester ? payKeys.testKey : payKeys.productionKeys.gk.cloudpayments.publicId; // PUBLIC_ID
};